module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar has-shadow"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "id": "brand-title",
      "to": "/"
    }
  }, [_vm._v("\n      E-Coin\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('p', {
    staticClass: "is-primary"
  }, [_vm._v("Blue: " + _vm._s(_vm.assets.blue))]), _vm._v(" "), _c('img', {
    staticClass: "currency",
    attrs: {
      "src": require("../assets/img/ecoin-blue.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_c('p', {
    staticClass: "is-primary"
  }, [_vm._v("Red: " + _vm._s(_vm.assets.red))]), _vm._v(" "), _c('img', {
    staticClass: "currency",
    attrs: {
      "src": require("../assets/img/ecoin-red.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navbar-item"
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-beafdba2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 164
// module chunks = 0